import React from "react";

const AutoReminderIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1673 10.9993C20.1673 5.93674 16.0633 1.83268 11.0007 1.83268C5.93804 1.83268 1.83398 5.93674 1.83398 10.9993C1.83398 16.062 5.93804 20.166 11.0007 20.166C16.0633 20.166 20.1673 16.062 20.1673 10.9993Z"
        stroke="#00B564"
        strokeWidth="1.5"
      />
      <path
        d="M7.33398 11.4583L9.62565 13.75L14.6673 8.25"
        stroke="#00B564"
        strokeWidth="1.5"
        strokelinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AutoReminderIcon;
